/* u14 */
export const ABMR_TEST = {
  DSA: "1",
  CARD16: "0.0",
  CD72: "0.73791",
  CD68: "0.894291",
  CCL4: "0.65754",
  CTLA4: "0.061842",
  PLA1A: "1.821715",
  ROBO4: "1.030584",
  KLRD1: "0.668815",
  FCGR3: "1.407115",
  GNLY: "1.621992",
  CXCL11: "0.582833",
  CCL18: "0.142334",
  CAV1: "1.741597",
  PECAM: "2.160262",
  PRF1: "0.674401",
  ADAMDEC1: "0.0",
  IFNG: "0.011315",
};

/* u132 */
export const TCMR_TEST = {
  DSA: "0",
  CARD16: "0.053294",
  CD72: "1.321752",
  CD68: "1.381456",
  CCL4: "0.70431",
  CTLA4: "0.779315",
  PLA1A: "0.855177",
  ROBO4: "0.599986",
  KLRD1: "0.579304",
  FCGR3: "1.402645",
  GNLY: "0.857842",
  CXCL11: "0.767159",
  CCL18: "0.946444",
  CAV1: "1.888493",
  PECAM: "1.870888",
  PRF1: "0.600696",
  ADAMDEC1: "0.5621",
  IFNG: "0.327378",
};

/* u135 */
export const CONTROL_TEST = {
  DSA: "0",
  CARD16: "0.241131",
  CD72: "0.756949",
  CD68: "1.739928",
  CCL4: "0.525371",
  CTLA4: "0.271907",
  PLA1A: "1.283266",
  ROBO4: "0.473347",
  KLRD1: "1.247359",
  FCGR3: "0.946825",
  GNLY: "0.458182",
  CXCL11: "0.191584",
  CCL18: "0.489828",
  CAV1: "2.344611",
  PECAM: "2.236774",
  PRF1: "0.213457",
  ADAMDEC1: "0.003462",
  IFNG: "0.192501",
};
